import { render, staticRenderFns } from "./tiwen.vue?vue&type=template&id=7f896f0f&scoped=true&"
import script from "./tiwen.vue?vue&type=script&lang=ts&"
export * from "./tiwen.vue?vue&type=script&lang=ts&"
import style0 from "./tiwen.vue?vue&type=style&index=0&id=7f896f0f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f896f0f",
  null
  
)

export default component.exports